import React from 'react';
import { OpportunityBoard } from '../../components/crm/OpportunityBoard';

export const PipelinePage: React.FC = () => {
  return <OpportunityBoard />;
};